const escapeMap: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
}

export function escapeHtml(text: unknown): string {
  if (typeof text !== "string") return ""
  return text.replace(/[&<>"']/g, (char) => escapeMap[char])
}

interface Segment {
  kind: "text" | "bold" | "italic";
  value: string;
}

function parseInlineMarkdown(text: string): Segment[] {
  const segments: Segment[] = []
  let i = 0
  while (i < text.length) {
    if (text[i] === "*" && text[i + 1] === "*") {
      const open = i
      const afterOpen = open + 2
      const close = text.indexOf("**", afterOpen)
      if (close !== -1 && close >= afterOpen) {
        segments.push({ kind: "bold", value: text.slice(afterOpen, close) })
        i = close + 2
        continue
      }
      segments.push({ kind: "text", value: text.slice(i) })
      break
    }
    if (text[i] === "*" && text[i + 1] !== "*") {
      const open = i
      const afterOpen = open + 1
      const close = text.indexOf("*", afterOpen)
      if (close !== -1 && close > afterOpen) {
        segments.push({ kind: "italic", value: text.slice(afterOpen, close) })
        i = close + 1
        continue
      }
      segments.push({ kind: "text", value: text.slice(i) })
      break
    }
    const nextBold = text.indexOf("**", i)
    const nextItalic = text.indexOf("*", i)
    let nextSpecial: number
    if (nextBold === -1 && nextItalic === -1) {
      nextSpecial = -1
    } else if (nextBold === -1) {
      nextSpecial = nextItalic
    } else if (nextItalic === -1) {
      nextSpecial = nextBold
    } else {
      nextSpecial = Math.min(nextBold, nextItalic)
    }
    if (nextSpecial === -1 || nextSpecial <= i) {
      segments.push({ kind: "text", value: text.slice(i) })
      break
    }
    if (nextSpecial > i) {
      segments.push({ kind: "text", value: text.slice(i, nextSpecial) })
    }
    i = nextSpecial
  }
  return segments
}

function renderSegments(segments: Segment[]): string {
  return segments
    .map((seg) => {
      const escaped = escapeHtml(seg.value)
      if (seg.kind === "bold") return `<strong>${escaped}</strong>`
      if (seg.kind === "italic") return `<em>${escaped}</em>`
      return escaped
    })
    .join("")
}

export function formatInlineBold(text: unknown): string {
  if (typeof text !== "string") return ""
  const html = renderSegments(parseInlineMarkdown(text))
  return `<span>${html}</span>`
}
